import { ParentAccountDto } from '@/models/suba/ParentAccountDTO.model';
import { ParentAccountGetByIdResponse } from '@vestwell-sub-accounting/sdk/dist/SubAccountingApiClient';

export const getParentAccountName = (
  parentAccount?: ParentAccountDto | ParentAccountGetByIdResponse,
  plan?: {
    name: string;
  }
) => {
  if (plan?.name) {
    return plan.name;
  }

  if (parentAccount && 'plan' in parentAccount && parentAccount.plan?.name) {
    return parentAccount.plan.name;
  }

  return parentAccount.accountName || '';
};
